// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dropdown-menu__item.ae-detail-cannot-operate-job {\n  pointer-events: none;\n  color: rgb(153, 153, 153);\n}\n", ""]);
// Exports
module.exports = exports;
